import { Stack, Group, Text } from '@mantine/core';
import { useState } from 'react';
import { TfiArrowTopRight } from 'react-icons/tfi';
import { FilterButtons } from 'src/components/FilterButtons/FilterButtons';
import { projects } from './projects';

const USECASES = [
  { value: 'lp', label: 'Liquidity Pool' },
  { value: 'collateral', label: 'Collateral' },
  { value: 'swap', label: 'Swap' },
  { value: 'options', label: 'Options' },
  { value: 'staking', label: 'Staking' },
  { value: 'lending/borrowing', label: 'Borrowing/Lending' },
  { value: 'strategy', label: 'Strategy' },
];

export function DefiPage() {
  const [activeFilter, setActiveFilter] = useState('all');
  return (
    <Stack gap={36}>
      <div>
        <FilterButtons
          data={['all', ...USECASES]}
          value={activeFilter}
          selectMaxW="1100"
          onChange={setActiveFilter}
        />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {projects
          .filter(
            (item) =>
              !!item.url &&
              (activeFilter === 'all' || item.usecases.includes(activeFilter))
          )
          .map((item) => {
            return (
              <a
                key={item.name}
                href={item.url}
                target="_blank"
                className="block outline outline-1 outline-[#202027] rounded-[16px] hover:outline-secondarybrand focus:outline-secondarybrand transition-colors"
              >
                <div className="relative p-5 rounded-[16px]">
                  <Stack gap={24}>
                    <Stack gap={12} align="flex-start">
                      <img
                        src={item.logo}
                        alt={`${item.name} Logo`}
                        className="h-[42px] object-contain rounded-[8px]"
                      />
                      <Text fz={24} fw={700} c="#E3E3E8">
                        {item.name}
                      </Text>
                    </Stack>

                    <Group gap={8}>
                      {item.usecases.map((usecase) => (
                        <Group
                          key={usecase}
                          className="py-[6px] px-2 rounded-[10px] outline outline-1 outline-solid outline-primarybrand"
                        >
                          <Text variant="gradient" fz={14} fw={600}>
                            {USECASES.find((_u) => _u.value === usecase)?.label}
                          </Text>
                        </Group>
                      ))}
                    </Group>
                  </Stack>

                  <TfiArrowTopRight
                    className="absolute top-5 right-5"
                    size={24}
                    color="var(--mantine-color-brand-0)"
                  />
                </div>
              </a>
            );
          })}
      </div>
    </Stack>
  );
}
